<template>
  <div class="card">
    <div class="card-body">
      <div class="card-title">
        <h2>
          카테고리 작성
        </h2>
        <p class="gray">카테고리를 작성합니다.</p>
      </div>
    </div>

    <el-form :model="frm" :rules="rules" ref="cgform" label-width="120px" class="demo-form">
      <div class="card-body gray">
        <div class="card-form textarea">
          <el-form-item label="상위카테고리" prop="parent_code">
            <div>
              <el-cascader
                :options="options"
                v-model="selectedOptions"
                separator=">"
                filterable
                change-on-select
                @change="handleChange"
                :disabled="isDisabled"
                style="width: 100%;">
              </el-cascader>
            </div>
          </el-form-item>
          <el-form-item v-if="isDisabled" label="카테고리코드" prop="cate_code">
            <el-input v-model.trim="frm.cate_code" :disabled="isDisabled"></el-input>
          </el-form-item>
          <el-form-item label="카테고리명" prop="kor_name">
            <el-input v-model.trim="frm.kor_name"></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="card-body text-right">
        <el-button @click="resetForm('cgform')">취소</el-button>
        <el-button type="danger" @click="deleteCategory">삭제</el-button>
        <el-button type="primary" @click="submitForm('cgform')">저장</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import common from '@/modules/common'
export default {
  name: 'M990402',
  mixins: [common.mixins],
  data () {
    return {
      isModify: false,
      isDisabled: true,
      frm: {
        cate_code: '',
        kor_name: '',
        parent_code: null,
        depth: 1,
        eng_name: '',
        initial_name: ''
      },
      options: [],
      selectedOptions: [],
      vals: [],
      rules: {
        cate_code: [
          { required: true, message: '코드ID를 입력하십시오.', trigger: 'blur' },
          { min: 1, max: 20, message: '최소 1자 이상 입력하십시오.' }
        ],
        kor_name: [
          { required: true, message: '카테고리명을 입력하십시오.', trigger: 'blur' },
          { min: 1, max: 50, message: '최소 1자 이상 입력하십시오.' }
        ],
        parent_code: [
          { required: true, message: '상위 카테고리명을 선택하십시오.', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    if (this.isEmptySeq(this.$route.params.cate_code) || this.$route.params.cate_code === 'NEW') {
      this.isDisabled = false
    }

    common.axios.get('/category/tree')
      .then(response => {
        // this.options = response.data
        this.options = [{
          children: response.data,
          label: 'TOP',
          parent: '',
          seq: 'TOP',
          value: 'TOP'
        }]
        const cateCode = this.$route.params.cate_code
        if (!this.isEmptySeq(cateCode) && cateCode !== 'NEW') {
          this.isModify = true
          this.loadData(this.$route.params.cate_code)
        }
      })
  },
  mounted () {
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const config = {
            url: this.isModify ? '/category' : '/category/storage',
            method: this.isModify ? 'put' : 'post',
            data: this.frm
          }
          common.axios.request(config)
            .then(response => {
              if (response.data.status === 1) {
                if (this.isModify) {
                  this.$message('수정하였습니다.')
                } else {
                  this.$message('등록하였습니다.')
                }
                setTimeout(() => {
                  this.$router.push({name: 'M990401', params: {isSearch: true}})
                }, 1000)
              }
            })
            .catch(error => {
              if (error.response.data.errors) {
                error.response.data.errors.map(msg => {
                  this.$message.error(msg)
                })
              }
            })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
          return false
        }
      })
    },
    resetForm (formName) {
      // if (this.$route.params.cate_code === '') {
      //   this.$refs[formName].resetFields()
      //   this.selectedOptions = []
      // } else {
      //   this.frm.kor_name = ''
      // }
      setTimeout(() => {
        this.$router.push({name: 'M990401'})
      }, 1000)
    },
    loadData (cateCode) {
      common.axios.get('/category/' + cateCode)
        .then(response => {
          const result = response.data
          Object.keys(this.frm).forEach(key => {
            this.frm[key] = result[key]
          })
          let res = result.select_option.split(' > ')
          this.selectedOptions = res
          this.selectedOptions.unshift('TOP')
        })
    },
    handleChange (value) {
      const lastValue = value.slice(-1)[0]
      const valueStatus = this.getValueStatus(this.options, lastValue)
      if (valueStatus.isLastValue) {
        this.$confirm('카테고리 마지막 항목에 추가하는 것이 맞으십니까?', '', {
        }).then(() => {
          this.frm.parent_code = lastValue
          this.vals = this.getCascaderObj(value, this.options)
        }).catch(() => {
          this.selectedOptions.pop()
          this.vals.pop()
        })
      } else {
        this.frm.parent_code = lastValue
        this.vals = this.getCascaderObj(value, this.options)
      }
    },
    getValueStatus (list, value) {
      let result = {isValue: false, isLastValue: false}
      for (const item of list) {
        const hasChildren = item.hasOwnProperty('children')
        if (item.value === value) {
          return {isValue: true, isLastValue: !hasChildren}
        }
        if (hasChildren) {
          result = this.getValueStatus(item.children, value)
          if (result.isValue) {
            break
          }
        }
      }
      return result
    },
    getCascaderObj (val, opt) {
      return val.map(value => {
        for (let itm of opt) {
          if (itm.value === value) {
            opt = itm.children
            return itm.label
          }
        }
        return null
      })
    },
    deleteCategory () {
      this.$confirm('삭제하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/category', {data: {cate_code: this.frm.cate_code}})
          .then(response => {
            this.$message('삭제되었습니다.')
            setTimeout(() => {
              this.$router.push({name: 'M990401'})
            }, 1000)
          })
          .catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M990402.vue